import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DetailsDialog } from './DetailsDialog';
import { NoteField } from './NoteField';

export interface NoteDialogProps {
  open: boolean;
  initialNote: string;
  onSave: (values: { note: string }) => void;
  onClose: () => void;
}

const MAX_NOTE_LENGTH = 1000;

export const NoteDialog = ({ open, initialNote, onSave, onClose }: NoteDialogProps) => {
  const { t } = useTranslation(['periverse']);
  const [noteDraft, setNoteDraft] = useState<string | null>(null);
  const note = noteDraft ?? initialNote;

  const handleClose = () => {
    setNoteDraft(null);
    onClose();
  };

  const handleSave = () => {
    onSave({ note: note.trim() });
    handleClose();
  };

  return (
    <DetailsDialog
      open={open}
      isEditing={!!initialNote}
      title={t('pages.entityManagement.noteDialog.title')}
      saveLabel={t('pages.entityManagement.noteDialog.save')}
      saveTestId="note-dialog-save"
      saveDisabled={note.length > MAX_NOTE_LENGTH}
      onSave={handleSave}
      onClose={handleClose}
    >
      <NoteField
        label={t('pages.entityManagement.noteDialog.title')}
        value={note}
        onChange={setNoteDraft}
        testId="note-dialog-note-input"
        helperText={t('pages.entityManagement.noteDialog.charCount', {
          current: String(note.length),
          max: String(MAX_NOTE_LENGTH),
        })}
      />
    </DetailsDialog>
  );
};
